import { lazy } from "react";
import HomePageLayout from "../layout/HomePage";
import GuestRoutes from "./GuestRoutes";
import Loader from "../Component/loader/Loader";

const HomePage = lazy(() => import("../Component/pages/homePage/HomePage"));
const ContentPages = lazy(
  () => import("../Component/pages/contentPages/ContentPages"),
);
const ViewServices = lazy(
  () => import("../Component/pages/homePage/ViewServices"),
);
const ViewSubCategories = lazy(
  () => import("../Component/pages/homePage/VewSubCategories"),
);

const HomeRoutes = {
  path: "",
  Component: GuestRoutes,
  children: [
    {
      path: "",
      element: <HomePageLayout />,
      children: [
        {
          path: "",
          element: <HomePage />,
        },
        {
          path: "view-all-services",
          element: <ViewServices />,
        },
        {
          path: "view-all-services/:serviceId",
          element: <ViewSubCategories />,
        },
        {
          path: "loader",
          element: <Loader />,
        },
        {
          path: "content/:pageKey",
          element: <ContentPages />,
        },
      ],
    },
  ],
};

export default HomeRoutes;
